module.exports = __webpack_public_path__ + "img/opinion.87d2fd39.svg";